/* eslint-disable lit-a11y/iframe-title */
import {
  asView,
  generateBindings,
  useMemo,
  view,
  View,
  ViewAnimation,
} from '@esui/core';
import { HSTack, VSTack } from '@esui/core/layout/index.js';
import { spread } from '@esui/core/utils/spread.js';
import { css, html } from 'lit';
import { ref } from 'lit/directives/ref.js';
import { styleMap } from 'lit/directives/style-map.js';
import { Text, TextScale } from '../text/index.js';

export function Section(title: string, ...content: View[]) {
  return VSTack(Text(title).font(TextScale.headline5), HSTack(...content));
}

export function VSection(title: string, ...content: View[]) {
  return VSTack(
    Text(title).font(TextScale.headline5),
    ...content
  ).templateColumns('90vw');
}

export function Title(text: string) {
  return Text(text).font(TextScale.headline5);
}

export function SLIDE_IN(): ViewAnimation[] {
  return [
    {
      keyframes: {
        opacity: ['0', '1'],
        transform: ['translateX(30rem)', 'translateX(0)'],
      },
      options: { duration: 300, fill: 'auto', easing: 'ease-out' },
    },
  ];
}

export function FADE_IN(): ViewAnimation[] {
  return [
    {
      keyframes: { opacity: ['0', '1'] },
      options: { duration: 500, fill: 'none', easing: 'ease-in' },
    },
  ];
}

export const [DemoPage] = view('demo-page', {
  Props: class {
    content: View[] = [];
  },

  mapBuilder:
    DemoPageBuilder =>
    (...content: View[]) =>
      DemoPageBuilder().content(content),

  template({ content }) {
    const slideIn = useMemo(FADE_IN, []);

    return VSTack(...content)
      .gridGap('2rem')
      .style('padding', '1rem 1rem 8rem')
      .withAnimations(slideIn)
      .className('container');
  },

  cssTemplate: css`
    .container[hidden] {
      opacity: 0;
    }
  `,

  noShadow: true,
});

export const [Iframe] = asView({
  Props: class {
    title = '';
    src = '';
  },

  template(props, { bindings, styles, elementRef }) {
    const myBindings = generateBindings(props);

    return html`
      <style>
        body {
          height: 100vh;
        }
      </style>
      <iframe
        ${spread({ ...bindings, ...myBindings })}
        style=${styleMap(styles)}
        ${ref(elementRef)}
      >
      </iframe>
    `;
  },
});
